import { render, staticRenderFns } from "./businessdetail.vue?vue&type=template&id=6b38bf1b&"
import script from "./businessdetail.vue?vue&type=script&lang=js&"
export * from "./businessdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports